import React from 'react'
import styled from 'styled-components'
import { Analysis } from '../Analysis'
import { CircledNumber } from 'packages/components/CircledNumber'
import { RichTextEditor, RichTextRenderer } from 'packages/components/RichText'
import {
  PaperAnswer,
  PaperBlock,
  PaperQuestion,
} from 'packages/sdks-next/growp'
import { useAnswersManagement } from '../context'
import { getReviewById, getValueById, updateAnswers } from '../utils'
import { TrueOrFalseTag } from '../TrueOrFalseTag'
import { QuizMode } from '../types'
import { getTheme } from '@/utils/theme'
import { ReadOver } from '../ReadOver'
import { AnyType } from 'packages/types'
import { CustomInput } from 'packages/components/CustomInput'
import { InputWithUpload } from './InputWithUpload'
import { cloneDeep } from '@seiue/util'

export const SubFillInBlank: React.FC<{
  mainQuestion: PaperQuestion
  block: PaperBlock
  curQuestion: PaperQuestion
  index: number
  subQuestionNum: number
  isAutoMode?: boolean
}> = ({
  mainQuestion,
  curQuestion,
  block,
  index,
  subQuestionNum,
  isAutoMode,
}) => {
  const theme = getTheme()
  const { mode, answers, setAnswers, reviews, isReviewed } =
    useAnswersManagement()
  const { value, answer } = getValueById(
    answers as PaperAnswer[],
    curQuestion.id
  )
  const { gainScore, result, review } = getReviewById(reviews, curQuestion.id)
  const cloneValue = cloneDeep(value)
  const textValue = value && value?.length > 0 ? value[0] : ''
  const attachList =
    cloneValue && cloneValue?.length > 1 ? cloneValue?.splice(1) : []
  const fileList = attachList.map((a) => JSON.parse(a))

  const onUpdateAnswers = (newValue: string[]) => {
    const newAnswers = updateAnswers(answers, {
      questionId: curQuestion.id,
      value: newValue,
    })
    setAnswers(newAnswers)
  }

  return (
    <div>
      <AnswerWrapper>
        <CircledNumber number={index + 1} />

        <div
          style={{
            flexGrow: 1,
          }}
        >
          <InputWithUpload
            disabled={[
              QuizMode.Completed,
              QuizMode.Review,
              QuizMode.Reviewed,
            ].includes(mode)}
            allowUploadImage={!isAutoMode}
            textValue={textValue}
            onTextValueChange={(v) => {
              let newValue = [v || '', ...attachList]
              if ((!attachList || !attachList.length) && !v) {
                newValue = []
              }
              onUpdateAnswers(newValue)
            }}
            fileList={fileList}
            onFileListChange={(filelist) => {
              let newValue = [textValue, ...filelist]
              if (!textValue && (!filelist || !filelist.length)) {
                newValue = []
              }
              onUpdateAnswers(newValue)
            }}
          />
        </div>
      </AnswerWrapper>
      {[QuizMode.Answering, QuizMode.Completed, QuizMode.Preview].includes(
        mode
      ) ? null : (
        <>
          {subQuestionNum === index + 1 ? (
            <Analysis
              mainQuestion={mainQuestion}
              block={block}
              LeftNode={
                <LeftNodeWrapper $hiddenAnalysis={false}>
                  {review || !answer?.answerId ? (
                    <TrueOrFalseTag
                      score={gainScore}
                      mode={result}
                    />
                  ) : (
                    <div style={{ minWidth: '84px' }} />
                  )}
                  {isAutoMode ||
                  isReviewed ||
                  mode === QuizMode.Reviewed ||
                  !answer?.answerId ? null : (
                    <ReadOver
                      score={curQuestion.score}
                      answer={answer as AnyType}
                      review={review}
                    />
                  )}
                </LeftNodeWrapper>
              }
            />
          ) : (
            <LeftNodeWrapper $hiddenAnalysis={false}>
              {review || !answer?.answerId ? (
                <TrueOrFalseTag
                  score={gainScore}
                  mode={result}
                />
              ) : (
                <div style={{ minWidth: '84px' }} />
              )}
              {isAutoMode ||
              isReviewed ||
              mode === QuizMode.Reviewed ||
              !answer?.answerId ? null : (
                <ReadOver
                  score={curQuestion.score}
                  answer={answer as AnyType}
                  review={review}
                />
              )}
            </LeftNodeWrapper>
          )}
        </>
      )}
    </div>
  )
}

const AnswerWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
`

const LeftNodeWrapper = styled.div<{ $hiddenAnalysis: boolean }>`
  height: ${(props) => (props.$hiddenAnalysis ? 0 : '32px')};
  padding-left: 26px;
  display: flex;
  align-items: flex-end;
  margin-bottom: 8px;
`
